export default __webpack_public_path__ + "static/media/main-logo.807be75c.png";